import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestBase } from "./request-base";

@Injectable()
export class FormulaService extends RequestBase {
    BasePath = 'api/formula';

    private static _Cache = {};

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetFormulaInfos(query): Promise<any> {
        return new Promise<any>(resolve => {
            let key = 'empty';
            if (query) {
                key = JSON.stringify(query);
            }
            const result = FormulaService._Cache[key];
            if (result) {
                resolve([...result]);
            } else {
                this.http.post<any>(this.API_BASE_URL + this.BasePath + '/GetFormulaInfos', query, this.options).subscribe(x => {
                    FormulaService._Cache[key] = x;
                    resolve([...x]);
                });
            }
        });
    }

    GetFormulaKeys(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetFormulaKeys', this.options);
    }
}